export default __webpack_public_path__ + "static/media/rr-testimonial.5857fed8.png";